// typeCategory
$(document).ready(function() {
  if ($('body').hasClass('type-category')) {

    $('<li class="col-xs-6 col-sm-6 col-lg-3 col-xl-3">' +
      '<a href="/pro-koho/">' +
      '<span class="image">' +
      '<img src="https://www.vyspimese.cz/user/documents/upload/temp/temp/navIcon/4/postele-pro-koho-min.jpg" alt="Pro koho">' +
      '</span>' +
      '<span class="text">Pro koho</span>' +
      '</a>' +
      '</li>')
      .prependTo('.in-postele ul.subcategories')

    // startMoveCategory
    function rearrangeElements() {
      const $categoryTop = $('main .category-top')
      const $contentWrapperIn = $('.content-wrapper-in')

      // Ochrana proti duplikaci a přemístění
      if (
        $categoryTop.length &&
        $contentWrapperIn.length &&
        !$contentWrapperIn.prev().is('.category-top')
      ) {
        $('main .category-top').not(':first').remove() // odstraní duplicity
        $categoryTop.first().show().insertBefore($contentWrapperIn) // zajistí zobrazení
      }

      const $bestsellerHeading = $('h4:contains("Nejprodávanější")')
      if ($bestsellerHeading.length && !$bestsellerHeading.parent().is('main')) {
        $bestsellerHeading.prependTo('main')
      }

      const $productsTop = $('#productsTop')
      if (
        $productsTop.length &&
        $bestsellerHeading.length &&
        !$productsTop.prev().is($bestsellerHeading)
      ) {
        $productsTop.insertAfter($bestsellerHeading)
      }
    }

// Spuštění při načtení stránky
    $(document).ready(function() {
      rearrangeElements()
    });

// Eventy od Shoptetu
    [
      'ShoptetContentLoaded',
      'ShoptetDOMContentLoaded',
      'ShoptetDOMPageContentLoaded'
    ].forEach(eventName => {
      document.addEventListener(eventName, function() {
        setTimeout(rearrangeElements, 50)
      })
    })

// Extra event: stránkování – skryjeme .category-top
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
      $('main .category-top').hide()
    })


    // end


    $('body').css('visibility', 'visible')
  }

  if ($('body.type-category .breadcrumbs span:contains(\'Lamelové rošty\')').length) {
    $('body').addClass('flag-lamelove-rosty')
  }

  if ($('body.type-category .breadcrumbs span:contains(\'Rošty do postele\')').length) {
    $('body').addClass('bed-slats')
  }

  if ($('body').hasClass('bed-slats')) {
    $(
      '<li class="item--box col-xs-6 col-sm-4 col-lg-3 col-xl-3"><a href="https://www.vyspimese.cz/jak-vybrat/jak-vybrat-rost-do-postele/" target="_blank" alt="" /></a></span><span class="text">Jak vybrat rošt do postele | Blog</span></li>'
    ).insertAfter('.subcategories li:last-of-type')
  }
})

// productCard
function moveProductDescriptions() {
  $('.product .p .p-desc').each(function() {
    $(this).insertAfter($(this).closest('.product').find('.name'))
  })
}

document.addEventListener('DOMContentLoaded', function() {
  moveProductDescriptions()
})

document.addEventListener('ShoptetContentLoaded', function() {
  moveProductDescriptions()
})

document.addEventListener('ShoptetDOMContentLoaded', function() {
  moveProductDescriptions()
})

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
  moveProductDescriptions()
})

document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
  moveProductDescriptions()
})

$('.type-category .subcategories li').removeClass('col-xl-2')
$('.type-category .subcategories li').addClass('col-xl-3')

$(document).ready(function() {
  $('.type-category label.filter-label.disabled').parent().addClass('disable-label')
  $('.type-category .disable-label').hide()

  $(
    '<span class="stars star-list"><span class="star star-off"></span><span class="star star-off"></span><span class="star star-off"></span><span class="star star-off"></span><span class="star star-off"></span></span>'
  ).appendTo('.product .p .stars-placeholder:empty')
})

$(document).on('ready ShoptetDOMContentLoaded', function() {
  $('.availability>span:contains(\'Skladem\')').addClass('skladem'),
    $('.availability>span:contains(\'do 5 dnů\')').addClass('skladem'),
    $('.availability>span:contains(\'do 7 dnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'Do 7 dnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'3 týdny\')').addClass('na-ceste'),
    $('.availability>span:contains(\'1-2 týdny\')').addClass('na-ceste'),
    $('.availability>span:contains(\'4-5 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'1-2 týdny\')').addClass('na-ceste'),
    $('.availability>span:contains(\'1-3 týdny\')').addClass('na-ceste'),
    $('.availability>span:contains(\'1-4 týdny\')').addClass('na-ceste'),
    $('.availability>span:contains(\'2-3 týdny\')').addClass('na-ceste'),
    $('.availability>span:contains(\'3-5 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'3-6 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'4-5 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'4-6 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'6-8 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'8-10 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'8 - 12 týdnů\')').addClass('na-ceste'),
    $('.availability>span:contains(\'Na objednávku\')').addClass('na-ceste'),
    $('.availability>span:contains(\'Na dotaz\')').addClass('vyprodano'),
    $('.availability>span:contains(\'Objednáno\')').addClass('vyprodano'),
    $('.availability>span:contains(\'Vyprodáno\')').addClass('vyprodano'),
    $('.availability>span:contains(\'po Vánocích\')').addClass('vyprodano'),
    $('.availability>span:contains(\'Momentálně nedostupné\')').addClass('vyprodano'),
    $('.id-1 .p-tools a.btn').html('Zobrazit detail'),
    $('.type-category .p-tools a.btn').html('Zobrazit detail'),
    $('.type-detail .products-related .p-tools a').html('Zobrazit detail'),
    $('.in-vyhledavani .p-tools a.btn').html('Zobrazit detail')
})

// Filtr
$('body.mobile .filters-unveil-button-wrapper a.btn').html('Filtrovat')


//og:image
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('type-category')) {
    var ogImageMeta = document.querySelector('meta[property="og:image"]')

    if (ogImageMeta && ogImageMeta.content) {
      var fullImageUrl = ogImageMeta.content
      var cleanImageUrl = fullImageUrl.split('?')[0] // odstraní případné parametry za otazníkem

      var structuredData = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': document.title,
        'description': document.querySelector('meta[name="description"]')?.content || '',
        'primaryImageOfPage': {
          '@type': 'ImageObject',
          'url': cleanImageUrl,
          'width': 1200,
          'height': 628,
          'caption': 'Hlavní obrázek kategorie'
        }
      }

      var script = document.createElement('script')
      script.type = 'application/ld+json'
      script.textContent = JSON.stringify(structuredData)
      document.head.appendChild(script)
    }
  }
})
